module.exports = __webpack_public_path__ + "img/ic_no_resume.60215118.svg";